module.exports = __webpack_public_path__ + "static/media/level1_q1_correct.e976eee0.png";